import React from "react";
import styled from "styled-components";

import baseStyles from "../../styles/baseStyles";

const Button = styled.button`
  text-transform: uppercase;
  text-align: center;
  cursor: pointer;
  padding: 0.5rem 2rem;
  height: 2.5rem;
  border-radius: 3px;
  box-shadow: ${baseStyles.layers.l2};
  transition: 0.2s all ease-in-out;
  letter-spacing: 1.2px;
  font-family: Lato;
  font-size: 15px;
  font-weight: 500;
  :hover {
    box-shadow: ${baseStyles.layers.l3};
  }
`;

const ButtonPrimary = styled(Button)`
  background-image: ${baseStyles.color.blueGradient};
  color: rgba(255, 255, 255, 0.95);
  border: none;
`;
const ButtonComponent = props => {
  return props.primary ? (
    <ButtonPrimary {...props}>{props.children}</ButtonPrimary>
  ) : (
    <Button {...props}>{props.children}</Button>
  );
};

export default ButtonComponent;



// WEBPACK FOOTER //
// ./src/components/UI/Button.js